<template>
  <div>
    <van-popup 
      v-model="$store.state.isShowInformPop" 
      round
      :close-on-click-overlay="false" 
      :style="{ width: '80%' }"
      get-container="body"
    >
      <div class="content-box">
        <div class="title">重要通知</div>
        <div class="text">
          各位经理，因微信风控问题，目前微信支付已经无法再正常使用，
          目前还未切换成银联支付的商家，顾客在报名时系统会提示【系统维护中，请以后再试】，
          同时请还没完成银联入网和认证的商家尽快处理。
          至于目前微信里还有钱未提的商家，我们后面跟财务沟通后协商一个处理方式再通知大家。

        </div>
        <div class="btn-box" @click="close">关闭</div>
      </div>
  </van-popup>
  </div>
</template>

<script>
export default {
  methods: {
    close(){
      this.$store.commit('setIsShowInformPop', false);
    }
  }
}
</script>

<style lang="stylus" scoped>
  .content-box {
    padding: 16px;
    .title {
      text-align: center;
      font-size: 17px;
      color: #333333;
      margin-bottom: 18px;
      font-weight: bold;
    }
    .text {
      color: #333333;
      line-height: 20px;
      .text-bottom {
        margin-top: 10px;
      }
    }
    .btn-box {
      height: 38px;
      line-height: 38px;
      text-align: center;
      color: #fff;
      background: linear-gradient( 180deg, #FF8820 0%, #FF6B31 100%);
      border-radius: 4px;
      margin-top: 20px;
      font-weight: bold;
    }
  }
</style>